(() => {
  'use strict';
  const mobile = window.matchMedia('(max-width: 989px)');
  function enhanceHeader(header) {
    if (!header || header.classList.contains('saba-header') || !window.HTMLDialogElement) return;
    const section = header.closest('.shopify-section');
    const configNode = section?.querySelector('[data-saba-header-config]') || document.querySelector('[data-saba-header-config]');
    let config;
    try { config = JSON.parse(configNode?.textContent || 'null'); } catch { return; }
    if (!Array.isArray(config?.items) || !config.items.length) return;
    const icons = header.querySelector('.header__icons');
    const search = icons?.querySelector('.header__search');
    if (!icons || !search) return;
    // Use Shopify's selected country, not the visitor's language or currency:
    // multiple countries can share the same currency. Keep Dawn's real form.
    header.querySelectorAll('localization-form').forEach(localization => {
      const countryCode = localization.querySelector('input[name="country_code"]')?.value;
      const button = localization.querySelector('.localization-form__select');
      const label = button?.querySelector('span');
      if (!/^[A-Z]{2}$/i.test(countryCode || '') || !button || !label) return;
      const originalLabel = label.textContent.replace(/\s+/g, ' ').trim();
      const currencyLabel = originalLabel.split('|').slice(1).join('|').trim();
      const flag = document.createElement('img');
      flag.className = 'saba-header__country-flag';
      flag.src = `https://cdn.shopify.com/static/images/flags/${countryCode.toLowerCase()}.svg?format=jpg&width=60`;
      flag.width = 60;
      flag.height = 45;
      flag.alt = '';
      flag.addEventListener('error', () => { flag.hidden = true; label.textContent = originalLabel; }, {once: true});
      button.prepend(flag);
      button.classList.add('saba-header__country-selector');
      button.setAttribute('aria-label', `Country and currency: ${originalLabel}`);
      if (currencyLabel) label.textContent = currencyLabel;
    });
    const prefix = `saba-menu-${section?.id || 'main'}`;
    const leading = document.createElement('div');
    leading.className = 'saba-header__leading';
    const menuButton = document.createElement('button');
    menuButton.type = 'button';
    menuButton.className = 'saba-header__menu-button';
    menuButton.setAttribute('aria-label', 'Menu');
    menuButton.setAttribute('aria-expanded', 'false');
    menuButton.setAttribute('aria-haspopup', 'dialog');
    menuButton.setAttribute('aria-controls', prefix);
    menuButton.innerHTML = '<span class="saba-header__hamburger" aria-hidden="true"></span><span class="saba-header__menu-label">Menu</span>';
    leading.append(menuButton);
    header.prepend(leading);

    const dialog = document.createElement('dialog');
    dialog.id = prefix;
    dialog.className = 'saba-menu';
    dialog.setAttribute('aria-label', 'SABA navigation');
    dialog.innerHTML = '<div class="saba-menu__bar"><p class="saba-menu__eyebrow">Explore SABA</p><button class="saba-menu__close" type="button" aria-label="Close menu"><svg aria-hidden="true" viewBox="0 0 20 20" fill="none"><path d="M3 3L17 17M17 3L3 17" stroke="currentColor" stroke-width="1.2"/></svg></button></div><div class="saba-menu__body"><nav class="saba-menu__categories" aria-label="Shop and discover"></nav><div class="saba-menu__panel" id="' + prefix + '-panel"><button type="button" class="saba-menu__back">← Back</button><h2 class="saba-menu__panel-title">Find your everyday favourites</h2><div class="saba-menu__links"></div></div></div>';
    document.body.append(dialog);
    const categories = dialog.querySelector('.saba-menu__categories');
    const panel = dialog.querySelector('.saba-menu__panel');
    const panelTitle = dialog.querySelector('.saba-menu__panel-title');
    const panelLinks = dialog.querySelector('.saba-menu__links');
    const back = dialog.querySelector('.saba-menu__back');
    let selectedButton = null;
    let previousOverflow = '';
    const localeRoot = window.Shopify?.routes?.root || '/';
    function safeUrl(path) {
      try {
        const url = new URL(path, location.origin);
        if (!['https:', 'http:'].includes(url.protocol)) return null;
        if (url.origin === location.origin && localeRoot !== '/' && !url.pathname.startsWith(localeRoot)) url.pathname = localeRoot.replace(/\/$/, '') + url.pathname;
        return url.href;
      } catch { return null; }
    }
    function link(label, url, className) {
      const anchor = document.createElement('a');
      anchor.className = className;
      anchor.textContent = label;
      anchor.href = safeUrl(url) || localeRoot;
      return anchor;
    }
    function showItem(item, button, focus = false) {
      selectedButton?.setAttribute('aria-expanded', 'false');
      selectedButton = button;
      button.setAttribute('aria-expanded', 'true');
      panelTitle.textContent = item.label;
      panelLinks.replaceChildren();
      if (item.url && item.url !== '#') panelLinks.append(link(`Explore ${item.label}`, item.url, 'saba-menu__view-all'));
      item.groups.forEach(group => {
        const wrapper = document.createElement('section');
        wrapper.className = 'saba-menu__group';
        const title = document.createElement('h3');
        title.textContent = group.label;
        const list = document.createElement('ul');
        group.links?.forEach(entry => {
          const row = document.createElement('li');
          row.append(link(entry.label, entry.url, ''));
          list.append(row);
        });
        wrapper.append(title, list);
        panelLinks.append(wrapper);
      });
      dialog.setAttribute('data-submenu-open', '');
      panel.scrollTop = 0;
      dialog.scrollTop = 0;
      if (focus) (mobile.matches ? back : panelLinks.querySelector('a'))?.focus();
    }
    config.items.forEach(item => {
      if (!item?.label || !Array.isArray(item.groups)) return;
      if (!item.groups.length) { categories.append(link(item.label, item.url, 'saba-menu__category')); return; }
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'saba-menu__category';
      button.textContent = item.label;
      button.setAttribute('aria-expanded', 'false');
      button.setAttribute('aria-controls', `${prefix}-panel`);
      button.insertAdjacentHTML('beforeend', '<svg aria-hidden="true" viewBox="0 0 12 12" fill="none"><path d="M4 2L8 6L4 10" stroke="currentColor" stroke-width="1.2"/></svg>');
      button.addEventListener('click', () => showItem(item, button, true));
      categories.append(button);
    });
    const utilities = document.createElement('div');
    utilities.className = 'saba-menu__utilities';
    const account = header.querySelector('.header__icon--account');
    if (account) { const accountLink = link('My Account', account.href, ''); accountLink.rel = 'nofollow'; utilities.append(accountLink); }
    const originalUtilities = header.querySelector('.menu-drawer__utility-links');
    const movedUtilities = [];
    originalUtilities?.querySelectorAll('.menu-drawer__localization, .list-social').forEach(el => { movedUtilities.push(el); utilities.append(el); });
    categories.append(utilities);
    const close = () => { if (dialog.open) dialog.close(); };
    const reset = () => {
      dialog.removeAttribute('data-submenu-open');
      selectedButton?.setAttribute('aria-expanded', 'false');
      panelTitle.textContent = 'Find your everyday favourites';
      panelLinks.replaceChildren();
      dialog.scrollTop = 0;
    };
    back.addEventListener('click', () => { reset(); selectedButton?.focus(); });
    dialog.querySelector('.saba-menu__close').addEventListener('click', close);
    // Only the native dialog backdrop closes the menu; content clicks stay inside.
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
    });
    dialog.addEventListener('cancel', event => { event.preventDefault(); close(); });
    dialog.addEventListener('close', () => {
      document.body.style.overflow = previousOverflow;
      menuButton.setAttribute('aria-expanded', 'false');
      reset();
      menuButton.focus({preventScroll: true});
    });
    dialog.addEventListener('keydown', event => {
      if (event.key === 'Tab') {
        const focusable = Array.from(dialog.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]):not([type="hidden"]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])'))
          .filter(el => el.getClientRects().length && getComputedStyle(el).visibility === 'visible' && !el.closest('[inert]'));
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
      }
      if (event.key === 'ArrowLeft' && mobile.matches && dialog.hasAttribute('data-submenu-open') && !event.target.matches('input,textarea,select')) {
        event.preventDefault(); back.click();
      }
    });
    menuButton.addEventListener('click', () => {
      header.querySelector('details-modal')?.close?.();
      reset();
      previousOverflow = document.body.style.overflow;
      dialog.showModal();
      document.body.style.overflow = 'hidden';
      menuButton.setAttribute('aria-expanded', 'true');
      if (!mobile.matches) {
        const firstGroup = config.items.find(item => item.groups?.length);
        const firstButton = categories.querySelector('button.saba-menu__category');
        if (firstGroup && firstButton) showItem(firstGroup, firstButton);
      }
      dialog.querySelector('.saba-menu__close').focus();
    });
    const sync = () => {
      if (mobile.matches) leading.append(search);
      else icons.insertBefore(search, header.querySelector('#cart-icon-bubble'));
      if (dialog.open) { reset(); dialog.querySelector('.saba-menu__close').focus(); }
      requestAnimationFrame(() => header.closest('sticky-header')?.setHeaderHeight?.());
    };
    sync();
    mobile.addEventListener('change', sync);
    // The live theme has an ID-scoped !important grid override. Inline priority
    // keeps the two side columns equal across all section IDs and page types.
    header.style.setProperty('grid-template-columns', 'minmax(0, 1fr) auto minmax(0, 1fr)', 'important');
    header.classList.add('saba-header');
    header.closest('.header-wrapper')?.classList.add('saba-header-shell');
    requestAnimationFrame(() => header.closest('sticky-header')?.setHeaderHeight?.());
    section?.addEventListener('shopify:section:unload', () => {
      close();
      mobile.removeEventListener('change', sync);
      dialog.remove();
      // Restore moved utilities when an editor keeps the old DOM temporarily.
      movedUtilities.forEach(el => originalUtilities?.append(el));
    }, {once: true});
  }
  const init = (root = document) => root.querySelectorAll('header.header').forEach(enhanceHeader);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), {once: true});
  else init();
  if (!window.sabaHeaderEditorListener) {
    window.sabaHeaderEditorListener = true;
    document.addEventListener('shopify:section:load', event => init(event.target));
  }
})();
